module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-10-c8e58313f9ecf945d8236fbf389a030d.jpg";